// extracted by mini-css-extract-plugin
export default {"navigator":"navigator_navigator__PIJfX","fixed":"navigator_fixed__SEAu7"};